import React from 'react';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

export const PlayIcon = ({ size = 'large' }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 41 41">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1168.000000, -436.000000)" fill="#FFFFFF">
                    <polygon
                        id="PlayIcon"
                        transform="translate(1188.500000, 456.500000) rotate(-270.000000) translate(-1188.500000, -456.500000) "
                        points="1188.5 436 1209 477 1168 477"
                    ></polygon>
                </g>
            </g>
        </svg>
    );
};
